module.exports = __webpack_public_path__ + "img/ai-guide.87e5da03.png";